import { http } from "./http";

/**
 * Providers de IA. O backend nunca devolve a chave de API — apenas a máscara,
 * o status e os modelos descobertos no último teste.
 */
export interface AiProviderModel {
  id: string;
  label?: string;
}

export interface AiProvider {
  id: string;
  provider: string;
  label: string | null;
  base_url: string | null;
  has_api_key: boolean;
  api_key_preview: string | null;
  default_model: string | null;
  role: "primary" | "fallback" | "secondary";
  is_active: boolean;
  is_default: boolean;
  models: AiProviderModel[];
  last_test: {
    status: "ok" | "failed" | null;
    message: string | null;
    tested_at: string | null;
  };
}

export interface AiProviderListMeta {
  supported_providers: { key: string; default_base_url: string | null }[];
  roles: string[];
  primary_provider: string | null;
  fallback_provider: string | null;
}

export interface AiProviderPayload {
  provider: string;
  label?: string | null;
  base_url?: string | null;
  api_key?: string | null;
  default_model?: string | null;
  role?: string;
  is_active?: boolean;
}

export interface AiProviderTestResult {
  ok: boolean;
  message: string;
  models: AiProviderModel[];
  duration_ms: number | null;
}

export const aiProviderService = {
  list: () =>
    http.getWithMeta<AiProvider[], AiProviderListMeta>("/ai/providers"),
  create: (payload: AiProviderPayload) =>
    http.post<AiProvider>("/ai/providers", payload),
  update: (id: string, payload: Partial<AiProviderPayload>) =>
    http.put<AiProvider>(`/ai/providers/${id}`, payload),
  remove: (id: string) => http.delete<{ deleted: boolean }>(`/ai/providers/${id}`),
  toggle: (id: string, isActive: boolean) =>
    http.post<AiProvider>(`/ai/providers/${id}/toggle`, { is_active: isActive }),
  test: (id: string) =>
    http.post<AiProviderTestResult>(`/ai/providers/${id}/test`),
};
